export const TEXTS = {
  POINT_CREATE_HINT_MODAL_TITLE: 'Почему важно указывать полный и корректный адрес?',
  POINT_CREATE_HINT_BUTTON_CANCEL: 'Хорошо',
  POINT_CREATE_HINT_DESCRIPTION:
    'Так мы сможем защитить вас в случае проверки. Дальнейшее изменение адреса возможно только через менеджера',
};
